/// <reference path="../_references.ts"/>

module App.Payment {
	import TitleBarService = App.Helpers.TitleBarService;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import Appointment = App.Appointments.Appointment;
	import UserSession = App.User.UserSession;
	import Countries = App.Country.Countries;
	import Validations = App.Validations.Validations;
	import WorkOrderService = App.WorkOrder.WorkOrderService;
	import ToastService = App.Utils.ToastService;
	import CustomerService = App.Customer.CustomerService;
	import OfficeService = App.Utils.OfficeService;

	export class PaymentController {
		showSaveAndSign: boolean = false;
		appointment: Appointment = null;
		paymentInfo: PaymentInfo = null;
		payment: Payment = null;
		financeCompanyName: string = '';
		paymentTypes: PaymentType[] = [];
		forms: { [key: string]: ng.IFormController } = {};
		isSaving: boolean = false;
		paymentData: PaymentData = null;

		editEmailFlyout: boolean = false;
		edittedEmail: string = '';
		showNewEmail: boolean = false;
		newEmail: string = '';
		resendFlyout: boolean = false;
		resendNote: string = '';
		resentPaymentId: number = null;

		tokenizerURL: string = null;

		static $inject: string[] = [
			'$scope', '$sce', '$q', 'TitleBarService', 'PaymentService', 'WorkOrderService', 'SelectedAppointment', 'UserSession', 'Countries',
			'Validations', 'ToastService', 'CustomerService', 'OfficeService', '$document'
		];

		constructor(
			public $scope: ng.IScope,
			private $sce: ng.ISCEService,
			protected $q: ng.IQService,
			private TitleBarService: TitleBarService,
			private PaymentService: PaymentService,
			private WorkOrderService: WorkOrderService,
			private SelectedAppointment: SelectedAppointment,
			private UserSession: UserSession,
			public countries: Countries,
			public validations: Validations,
			public ToastService: ToastService,
			public CustomerService: CustomerService,
			private OfficeService: OfficeService,
			private $document: ng.IDocumentService,
		) {
			TitleBarService.set('Appointment');

			this.tokenizerURL = this.$sce.trustAsResourceUrl(this.getTokenizerURL());

			OfficeService.getAppointment().then(response => {
				this.setAppointment(response.data);
			})
			.catch(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					this.setAppointment(appointment);
				});
			});
		}

		getTokenizerURL(): string {
			const tokenizerURL = 'https://fts.cardconnect.com:8443/itoke/ajax-tokenizer.html'
				+ '?formatinput=true'
				+ '&tokenizewheninactive=false'
				+ '&css='
					+ encodeURI((
						'body {'
							+ 'margin: 0;'
							+ 'max-width: 100%;'
						+ '}'
						+ 'input {'
							+ 'width: 1px;'
							+ 'min-width: 100%;'
							+ 'display: inline-block;'
							+ 'outline: 0;'
							+ 'font-size: 1.2rem;'
							+ 'border-radius: 5px;'
							+ 'padding: 20px;'
							+ 'height: 24px;'
							+ 'border: 2px solid rgba(0,0,0,.12);'
							+ 'background: transparent;'
							+ 'color: black;'
						+ '}'
					).replace(/(:|\{|;)\s+/g, '$1').replace(/\s+(\{)/g, '$1'));

			return tokenizerURL;
		}

		setPaymentData() {
			const vm = this;

			return vm.PaymentService.fetchPaymentTypes().then((response) => {
				const email = vm.appointment.service_request.customer.emails.length ? vm.appointment.service_request.customer.emails[0].email : null;

				vm.paymentTypes = response.data;

				vm.payment = new Payment(
					null,
					email,
					vm.UserSession.user && vm.UserSession.user.id || null,
					vm.paymentInfo.amount_due
				);
				vm.selectPaymentType(vm.appointment.service_request.payment_type.name.toLowerCase());

				// This shouldn't be necessary, but for some reason it is.  Causes the switch to appear after navigation - otherwise only appears on refresh.
				const switchElement: HTMLElement = this.$document[0].getElementById('send-email-switch');
				componentHandler.upgradeElement(switchElement);

				// This shouldn't be necessary either, but mdl doesn't ensure that the switch is the right state when creating it.
				switchElement.querySelector('input').click();

				vm.setFinancing();
			});
		}

		getPaymentType(payment: Payment): string {
			switch (payment.type) {
				case 'Cash': return 'Payment';
				default: return payment.type;
			}
		}

		setAppointment(appointment: Appointment): ng.IPromise<void> {
			const vm = this;

			vm.appointment = appointment;

			vm.setCreditCardDetails();
			return vm.getPaymentsData();
		}

		getPaymentsData() {
			const vm = this;

			return vm.PaymentService.fetchPaymentInfo(vm.appointment.service_request.id).then((response) => {
				vm.paymentInfo = response.data;

				vm.setPaymentData();
			});
		}

		setFinancing() {
			const vm = this;

			if(vm.paymentInfo.finance_plan) {
				vm.payment.payment_type = vm.paymentTypes.find((type) => {
					return type.name.toLowerCase() === 'financing';
				}).name;

				vm.WorkOrderService.getFinancePlan(vm.paymentInfo.finance_plan.id).then((response) => {
					vm.financeCompanyName = response.data.finance_company.name;
				});
			}
		}

		dateFormatter(date: string) {
			return moment(date).format('D MMM YY');
		}

		selectPaymentType(pType: string) {
			if (pType === 'invoice') {
				pType = 'cash';
			}
			this.payment.payment_type = this.paymentTypes.find((type) => {
				return type.name.toLowerCase() === pType;
			}).name;
		}

		isSelectPaymentType(pType: PaymentTypeName) {
			return this.payment && this.payment.payment_type.toLowerCase() === pType;
		}

		setCreditCardDetails() {
			const vm = this;

			let custName = vm.appointment.service_request.customer.full_name.split(" ");
			vm.paymentData = {
				firstName: custName[0],
				lastName: custName[custName.length - 1],
				mI: custName.length > 2 ? custName[1][0] : null,
				billingAddress: vm.appointment.service_request.service_address.address.substr(0, vm.appointment.service_request.service_address.address.lastIndexOf(" ")),
				postalCode: vm.appointment.service_request.service_address.address.substr(vm.appointment.service_request.service_address.address.lastIndexOf(" ") + 1)
			}

			vm.CustomerService.fetchCustomerAddress(vm.appointment.service_request.customer.id).then((result) => {
				if (result.data !== null) {
					let recentAddress = result.data.find((addr) => {
						return addr.latitude === vm.appointment.service_request.service_address.latitude;
					});

					if (!recentAddress) {
						recentAddress = result.data[result.data.length - 1];
					}
					vm.paymentData.postalCode = recentAddress.zip;
					vm.paymentData.billingAddress = recentAddress.address.substr(0, recentAddress.address.lastIndexOf(" "));
				}
			})
		}

		saveDisabled(): boolean {
			if(this.payment && this.payment.payment_type && this.forms[this.payment.payment_type.toLowerCase()]) {
				return this.forms[this.payment.payment_type.toLowerCase()].$invalid || this.payment.payment_type.toLowerCase() === 'invoice';
			} else {
				return false;
			}
		}

		toggleShowSaveAndSign() {
			if(this.saveDisabled()) {
				return;
			}

			this.showSaveAndSign = !this.showSaveAndSign;
		}

		isSignatureEmpty() {
			return this.payment === null || !Boolean(this.payment.signature);
		}

		isPrintNameEmpty() {
			return this.payment === null || this.payment.print_name === null;
		}

		activateTokenListener(): void {
			const vm = this;

			vm.payment.details = null;

			window.addEventListener('message', (event) => {
				vm.payment.details = JSON.parse(event.data).message;
				this.$scope.$apply();
			}, false);
		}

		savePaymentFormFromInput(event: any) {
			if (event.keyCode === 13) {
				event.target.blur();
				this.savePaymentForm();
			}
		}

		savePaymentForm(): null | void {
			const vm = this;

			if(vm.isSignatureEmpty() || vm.isPrintNameEmpty()) {
				return null;
			}

			vm.isSaving = true;

			vm.payment.technician = vm.UserSession.user
				&& vm.UserSession.user.technician
				&& vm.UserSession.user.technician.id
				|| null;

			vm.payment.appointment = vm.appointment.id;

			if (!vm.payment.email) {
				vm.payment.email_sent = false;
			}

			let saving1 = this.$q.defer(),
				saving2 = this.$q.defer();

			vm.PaymentService.createPayment(vm.appointment.service_request.id, vm.payment).then((response) => {
				vm.showSaveAndSign = false;
				this.payment.signature = '';

				vm.getPaymentsData().then(() => {
					saving1.resolve();
				});

				vm.ToastService.show('Approved');
				return response.data.id;
			}, (response) => {
				vm.ToastService.showError('Unable to process payment: ', response);
				saving1.resolve();
			}).then((id: number) => {
				if (id && vm.payment.email_sent) {
					vm.sendEmail(id).then(() => {
						saving2.resolve();
					});
				} else {
					saving2.resolve();
				}
			});

			this.$q.all([saving1.promise, saving2.promise]).then(() => {
				this.isSaving = false;
			});
		}

		toggleResendFlyout(id?: number) {
			this.resendFlyout = !this.resendFlyout;
			if (id) {
				this.resentPaymentId = id;
			}
		}

		sendEmail(resentId?: number, email?: string, note?: string) {
			return this.PaymentService.sendPaymentEmail(this.appointment.service_request.id, resentId || this.payment.id, {
				email: email || this.payment.email,
				note: note || this.payment.email_note
			}).then(() => {
				this.ToastService.show('Email sent');
				if (this.resendFlyout) {
					this.toggleResendFlyout();
				}
			}).catch(() => {
				this.ToastService.showError('Email failed to send.  Click on the payment above to resend.')
			});
		}

		editEmail() {
			this.payment.email = this.edittedEmail;
			this.editEmailFlyout = false;

			if (this.showNewEmail) {
				this.CustomerService.createEmail(this.appointment.service_request.customer.id, this.newEmail).then((email) => {
					this.appointment.service_request.customer.emails.push(email.data);
					this.payment.email = this.edittedEmail = email.data.email;
					this.newEmail = '';
					this.showNewEmail = false;
					this.ToastService.show('Email created');
				});
			}
		}
	}
}
